// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_List from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as CurrencyMajorMinorMapper from "../../../../../../../../../library/data-source/country-currency/CurrencyMajorMinorMapper.bs.js";

function generateIdsFromRange(start, end) {
  var customer_ids = /* [] */0;
  for(var x = start; x <= end; ++x){
    customer_ids = Belt_List.add(customer_ids, x);
  }
  return Belt_List.reverse(customer_ids);
}

function execute(state, core_pricing_external_id) {
  if (state.TAG === /* AB */0) {
    var eligiblity_rules = state.eligiblity_rules;
    var slab_details_test = state.slab_details_test;
    var base_details_control = state.base_details_control;
    var base_details_test = state.base_details_test;
    var key_details = state.key_details;
    var ids = Belt_Array.slice(key_details.test_ids, 0, Caml_format.caml_int_of_string(key_details.test_group));
    var ids$1 = Belt_Array.slice(key_details.test_ids, 0, Caml_format.caml_int_of_string(key_details.test_group));
    var days = eligiblity_rules.days;
    return {
            modification_type: /* AB */1,
            name: key_details.name,
            core_pricing_external_id: core_pricing_external_id,
            start_date: key_details.start_date,
            end_date: key_details.end_date,
            base_details: {
              base_detail_test: Belt_Array.mapWithIndex(ids, (function (index, id_bucket) {
                      var base_detail_test = Belt_Array.getExn(base_details_test, index);
                      return {
                              test_details: {
                                base_fare_delta: CurrencyMajorMinorMapper.currencyToBase(base_detail_test.base_fare_delta),
                                free_duration_delta: base_detail_test.free_duration_delta,
                                waiting_rate_per_min_delta: CurrencyMajorMinorMapper.currencyToBase(base_detail_test.waiting_rate_per_min_delta),
                                free_kms_delta: base_detail_test.free_kms_delta,
                                free_km_price_per_min_delta: CurrencyMajorMinorMapper.currencyToBase(base_detail_test.free_km_price_delta)
                              },
                              customer_id_buckets: generateIdsFromRange(Caml_format.caml_int_of_string(id_bucket.start), Caml_format.caml_int_of_string(id_bucket.end))
                            };
                    })),
              control_details: {
                base_fare_delta: CurrencyMajorMinorMapper.currencyToBase(base_details_control.base_fare_delta),
                free_duration_delta: base_details_control.free_duration_delta,
                waiting_rate_per_min_delta: CurrencyMajorMinorMapper.currencyToBase(base_details_control.waiting_rate_per_min_delta),
                free_kms_delta: base_details_control.free_kms_delta,
                free_km_price_per_min_delta: CurrencyMajorMinorMapper.currencyToBase(base_details_control.free_km_price_delta)
              }
            },
            slab_details: {
              slab_detail_test: Belt_Array.mapWithIndex(ids$1, (function (index, id_bucket) {
                      var slab_detail_test = Belt_Array.getExn(slab_details_test, index);
                      return {
                              test_details: List.map((function (s) {
                                      return {
                                              slab_km: s.slab_km,
                                              price_per_min: s.price_per_min,
                                              price_per_km: s.price_per_km
                                            };
                                    }), slab_detail_test),
                              customer_id_buckets: generateIdsFromRange(Caml_format.caml_int_of_string(id_bucket.start), Caml_format.caml_int_of_string(id_bucket.end))
                            };
                    })),
              control_details: List.map((function (s) {
                      return {
                              slab_km: s.slab_km,
                              price_per_min: s.price_per_min,
                              price_per_km: s.price_per_km
                            };
                    }), state.slab_details_control)
            },
            validations: {
              start_time: eligiblity_rules.start_time,
              end_time: eligiblity_rules.end_time,
              repeat_days: days ? days : undefined,
              pick_up_zone: eligiblity_rules.pickup_zone,
              pick_up_cluster: eligiblity_rules.pickup_cluster,
              drop_zone: eligiblity_rules.drop_zone,
              drop_cluster: eligiblity_rules.drop_cluster
            }
          };
  }
  var eligiblity_rules$1 = state.eligiblity_rules;
  var base_details = state.base_details;
  var key_details$1 = state.key_details;
  var days$1 = eligiblity_rules$1.days;
  return {
          modification_type: /* Simple */0,
          name: key_details$1.name,
          core_pricing_external_id: core_pricing_external_id,
          start_date: key_details$1.start_date,
          end_date: key_details$1.end_date,
          base_details: {
            base_detail_test: undefined,
            control_details: {
              base_fare_delta: CurrencyMajorMinorMapper.currencyToBase(base_details.base_fare_delta),
              free_duration_delta: base_details.free_duration_delta,
              waiting_rate_per_min_delta: CurrencyMajorMinorMapper.currencyToBase(base_details.waiting_rate_per_min_delta),
              free_kms_delta: base_details.free_kms_delta,
              free_km_price_per_min_delta: CurrencyMajorMinorMapper.currencyToBase(base_details.free_km_price_delta)
            }
          },
          slab_details: {
            slab_detail_test: undefined,
            control_details: List.map((function (s) {
                    return {
                            slab_km: s.slab_km,
                            price_per_min: s.price_per_min,
                            price_per_km: s.price_per_km
                          };
                  }), state.slab_details)
          },
          validations: {
            start_time: eligiblity_rules$1.start_time,
            end_time: eligiblity_rules$1.end_time,
            repeat_days: days$1 ? days$1 : undefined,
            pick_up_zone: eligiblity_rules$1.pickup_zone,
            pick_up_cluster: eligiblity_rules$1.pickup_cluster,
            drop_zone: eligiblity_rules$1.drop_zone,
            drop_cluster: eligiblity_rules$1.drop_cluster
          }
        };
}

export {
  generateIdsFromRange ,
  execute ,
  
}
/* No side effect */
